import { j as i } from "./jsx-runtime-944c88e2.js";
import { h as r } from "./index-b1011fa6.js";
import { w as p, a as e } from "./filter-data-d3e34102.js";
import { forwardRef as l } from "react";
import { P as a } from "./Popup-b6c9078b.js";
import "./index-efd35e77.js";
import "./index-c07310bf.js";
import "./index-64063129.js";
import "react-dom";
import "./auto-scroll-b2de6e53.js";
import "./FloatingLabel-922c628f.js";
import "./index-93802845.js";
import "./package-metadata-3dcf116a.js";
import "./index.es-6889c727.js";
import "./index-a0534bb4.js";
import "./Label-079ad7bc.js";
import "./Button-4c83e316.js";
import "./package-metadata-9ad1330d.js";
import "./theme-b013fa81.js";
import "./ButtonGroup-a9850ef0.js";
import "./surface-71c0d1c6.js";
import "./Dialog-a72b336a.js";
import "./Chip-cb37946d.js";
import "./keys-2b65407d.js";
import "./TreeView-aa1ef3e3.js";
import "./Reveal-e2f427f6.js";
import "./Animation-d8a017b3.js";
import "./TransitionGroup-34043d49.js";
import "./ActionSheet-b5bf2237.js";
import "./Animation-154b683d.js";
import "./noop-d627517c.js";
import "./package-metadata-a152adb8.js";
const O = l(function(t, o) {
  return /* @__PURE__ */ i.jsx(
    a.Provider,
    {
      value: (m) => ({
        ...m,
        collision: {
          vertical: "none",
          horizontal: "none"
        }
      }),
      children: t.filterable ? /* @__PURE__ */ i.jsx(n, { ...t, ref: o }) : /* @__PURE__ */ i.jsx(r, { ...t, ref: o })
    }
  );
}), n = p(e(r));
export {
  O as MultiSelect
};
